window.addEventListener('OpusCartChange', (event) => {
  const data = event.detail;
  const findSelectEl = document.querySelector('.opus-price-ct-container');
  if (findSelectEl) {
    findSelectEl.remove();
  }

  const isPriceDiscount = data.original_total_price - data.total_price > 0;
  const checkoutBtn = document.querySelector('#opus-checkout-btn-2');

  console.log('data.money', data.total_price < 150000, data.total_price)

  if (checkoutBtn) {
    // Commented out the incentive message block
    /*
    checkoutBtn.insertAdjacentHTML(
      "beforebegin",
      `<div class="opus-price-ct-container" style="width: 100%; display: inline-flex; padding-top: 15px; justify-content: end; align-items: center; font-size: 16px; font-weight: bold; gap: 20px; text-transform: uppercase; margin: auto;">
        <ul style="list-style: none; padding: 0; margin: 0;">
          ${data.total_price < 150000 ? `
          <li  style="display: flex; align-items: flex-end; gap: 5px; color: red;">
             <img src="https://cdn.shopify.com/s/files/1/0879/4882/0768/files/discount-38.svg?v=1743153525" alt="Discount Icon" width="15" height="15" style="display: inline-block;">
            <span style="font-size: 12px;color: #c74230;">Spend $1,500 & get a 15% Off</span>
          </li>` : ''}
        </ul>
      </div>`
    );
    */
  }
});
